import { isDefined } from 'utils/type-guard/isDefined'
import { scoreRecordToSet } from '../helpers/scoreRecordToSet'
import { RiskMethodologyCalculator } from '../RiskMethodologyCalculator'

export const RiskMethodologyCalculatorMultiply: RiskMethodologyCalculator = {
  getRiskScore: ({ probabilityId, probabilities, impactId, impacts }) => {
    const probability = probabilities.find((item) => item.id === probabilityId)
    const impact = impacts.find((item) => item.id === impactId)
    if (!probability || !impact) return { label: null }

    const score = probability.score * impact.score

    return {
      label: String(score),
      score,
    }
  },
  getRiskScoreValue: ({ impactScore, probabilityScore }) =>
    isDefined(impactScore) && isDefined(probabilityScore) ? impactScore * probabilityScore : undefined,
  getChipLabel: ({ label }) => label,
  getPossibleScores: ({ impacts, probabilities }) => ({
    riskMatrixScores: Array.from(
      new Set(
        impacts.reduce((acc, impact) => {
          probabilities.forEach((probability) => {
            acc.push(impact.score * probability.score)
          })
          return acc
        }, [] as number[])
      )
    ).sort((a, b) => a - b),
    impactScores: scoreRecordToSet(impacts),
    probabilityScores: scoreRecordToSet(probabilities),
  }),
  getMethodology: () => 'MULTIPLY',
}
